import { type WidgetStates } from '@pages/auth/Register/model/viewModel';
import { NavigateFunction } from 'react-router-dom';
import { SubmitHandler } from 'react-hook-form';
import { UserInfo } from '@pages/auth/Register/config/validation';

export interface IRegisterPageViewModel {
  state: WidgetStates;
  socket: WebSocket;
  botUrl: string;
  phone: string;
  isContacted: boolean;
  userId: number | null;
  selectedVerifyMethod: 'Telegram';
  navigate: NavigateFunction | null;

  initFlow: () => Promise<void>;
  cleanup: () => void;
  cancelRegistration: () => void;
  goToVerifyCode: () => void;
  goToChangePassword: () => void;
  goToUserInfo: () => void;
  setUserId: (userId: number | null) => void;
  onSuccessVerifyCode: (userId: number | null) => void;
  returnToLogin: () => void;
  onPasswordChanged: () => void;
  onUserInfoSubmit: SubmitHandler<UserInfo>;
}

export const RegisterPageViewModelToken = Symbol.for('IRegisterPageViewModel');
